export default "__VITE_ASSET__CZ2gmLmn__"